<template>
    <div>
        <br>
        <el-row :gutter="50" class="apps-container" justify="space-around">
            <el-col :span="12" v-for="(link) in links" :key="link.name">
                <div class="grid-content-apps">
                    <h3>
                        <router-link :to="link.route">
                            {{ link.name }}
                        </router-link>
                    </h3>
                    <p>{{ link.description }}</p>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" v-if="showUserRequests && userInfo.cat_profile_id == 1">
            <el-col :span="24">
                <span>
                    <div class="tip-red">
                        Algunos usuarios han actualizado su información o cambiaron su perfil, seleccione para aprobar o rechazar su solicitud.
                    </div>
                    <el-table :data="userRequests" border stripe>
                        <el-table-column label="Usuario" prop="user.username"/>
                        <el-table-column label="Nombre Completo" prop="user.full_name"/>
                        <el-table-column label="Oficina" prop="user.office.name"/>
                        <el-table-column label="Acciones" align="center">
                            <template slot-scope="props">
                                 <el-tooltip class="item"
                                             effect="dark"
                                             content="Ver Usuario"
                                             placement="top-end">
                                        <el-button type="info"
                                                   icon="fas fa-eye"
                                                   size="mini"
                                                   round
                                                   @click="goToUser(props.row.user.hash_id)">
                                        </el-button>
                                 </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </span>
            </el-col>
        </el-row>
    </div>
</template>

<script>

    export default {
        computed: {
            userInfo() {
                return this.$store.state.user.user;
            },
        },
        data() {
            return {
                links: [],
                userRequests: [],
                showUserRequests: false
            }
        },

        created() {
            axios.get('/api/links-home').then(response => {
                this.links = response.data.links;
            });
            axios.get('/api/get-user-requests').then(response => {
                if(response.data.success
                    && response.data.userRequests
                    &&response.data.userRequests.length > 0){
                    this.showUserRequests = true;
                    this.userRequests = response.data.userRequests
                }
            });
        },

        methods:{
            goToUser(user){
                if(user){
                    this.$router.push({
                        path: '/administracion/usuarios/editar/'+ user
                    });
                }

            }
        }
    }
</script>
<style>
    .card-home {}

    .apps-container {
        padding: 0 10px 0 30px;
    }

    .grid-content-apps a {
        color: #9D2449;
    }
</style>
